// @flow
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

// Components
import InfoPanel from './InfoPanel';

// Selectors
import {
  getDealerCountryCode,
  isRegistrationNumEnabled
} from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = state => ({
  dealerCountryCode: getDealerCountryCode(state),
  isRegistrationNumEnabled: isRegistrationNumEnabled(state)
});

export default compose(
  injectIntl,
  connect(mapStateToProps)
)(InfoPanel);



// WEBPACK FOOTER //
// ./src/components/atoms/InfoPanel/InfoPanelContainer.js